var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer bg-light"},[_c('small',{staticClass:"footer-text"},[_vm._v(" Corendon Airlines © "+_vm._s(new Date().getFullYear())+" - All Rights Reserved."),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }